<template>
  <section>
    <div class="container pt-5 pb-5">
      <div class="columns is-vcentered">
        <div class="column is-6">
          <h1 class="title is-4 mb-0 has-text-primary has-text-centered-mobile">
            <span class="icon">
              <i class="mdi mdi-cart"></i>
            </span>
            <span>CARRITO</span>
          </h1>
        </div>
        <div class="column is-6 has-text-right has-text-centered-mobile">
          <b-button
            v-if="total_items > 0"
            type="is-danger"
            outlined
            icon-left="delete"
            :disabled="isSyncing > 0"
            :loading="isSyncing > 0"
            @click="emptyCart()"
            >VACIAR CARRITO</b-button
          >
        </div>
      </div>

      <section v-if="order">
        <div
          v-for="(item, item_index) in order.items"
          :key="item_index"
          class="card mb-1"
        >
          <div class="card-content">
            <div class="columns is-vcentered">
              <div class="column has-text-centered-mobile is-1">
                <media-img
                  :img="item.img"
                  bgsize="contain"
                  size="100x80"
                ></media-img>
              </div>
              <div class="column has-text-centered-mobile is-7">
                <div><b>Cantidad y Descripción</b></div>

                <div class="columns">
                  <div class="column is-4">
                    <b-numberinput
                      :editable="false"
                      :loading="isSyncing > 0"
                      min="1"
                      :max="item.stock"
                      type="is-light"
                      v-model="item.quantity"
                      @input="debouncedChangeItemQuantity(item)"
                    ></b-numberinput>
                  </div>
                  <div class="column is-8">
                    <b>{{ item.description }}</b>
                  </div>
                </div>
              </div>

              <div class="column has-text-centered-mobile is-1">
                <div><b>Precio</b></div>
                <span>{{ item.unitary_price | currency }}</span>
              </div>

              <div class="column has-text-centered-mobile is-2">
                <div><b>Importe</b></div>
                <span
                  ><b class="has-text-primary">{{
                    item.total | currency
                  }}</b></span
                >
              </div>

              <div class="column has-text-centered-mobile is-1">
                <b-button
                  type="is-light"
                  class="has-text-danger"
                  icon-left="close"
                  :disabled="isSyncing > 0"
                  :loading="isSyncing > 0"
                  @click="removeItem(item)"
                ></b-button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="order.items.length === 0" class="card">
          <div class="card-content">
            <div class="has-text-centered">
              <h1 class="title is-2 has-text-grey">
                <b-icon size="is-large" icon="cart-off"></b-icon>
              </h1>
              <h1 class="title is-4 has-text-grey">Tu carrito está vacío</h1>
            </div>
          </div>
        </div>

        <div class="card mb-2" v-if="has_cart_suggestions">
          <div class="card-content">
            <h1 class="title is-5 has-text-primary has-text-centered-mobile">
              Recomendaciones de acuerdo a tu compra
            </h1>
            <div class="columns is-multiline is-4">
              <div
                v-for="(suggestion, code) in cart_suggestions"
                :key="code"
                v-show="suggestion.stock > 0"
                class="column is-4"
              >
                <div class="level is-mobile">
                  <div class="level-left">
                    <div
                      class="level-item has-text-centered-mobile"
                      style="max-width: 90px"
                    >
                      <media-img
                        :img="suggestion.img"
                        bgsize="contain"
                        size="100x80"
                        mobile_size="100x80"
                      ></media-img>
                    </div>

                    <div class="level-item">
                      <div>
                        <div class="is-size-7" style="max-width: 180px">
                          <a :href="suggestion.link">{{ suggestion.title }}</a>
                        </div>
                        <div>
                          <div
                            v-if="
                              suggestion.current_price &&
                              suggestion.current_price.has_discount
                            "
                          >
                            <div>
                              <b>{{
                                suggestion.current_price.discount_value
                                  | currency
                              }}</b>
                            </div>
                            <div class="is-size-6">
                              <del>{{
                                suggestion.current_price.value | currency
                              }}</del>
                            </div>
                          </div>
                          <div v-else>
                            <b>{{ suggestion.price | currency }}</b>
                          </div>
                          <div class="mt-2">
                            <add-to-cart
                              :data="suggestion"
                              size="is-small"
                              :silent="true"
                              @pushed="getOrder()"
                            ></add-to-cart>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="level-right"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-content">
            <h5 class="title is-5 has-text-primary">
              Elige un método de entrega
            </h5>
            <div class="columns mt-3 is-vcentered is-gapless">
              <div class="columns is-6">
                <div class="columns is-mobile is-vcentered is-gapless">
                  <div class="column is-2">
                    <div class="p-2 has-text-centered">
                      <b-icon
                        class="has-text-primary"
                        size="is-large"
                        icon="truck-delivery-outline"
                      ></b-icon>
                    </div>
                  </div>
                  <div class="column">
                    <div class="p-2">
                      <b-radio
                        v-model="shipping_method"
                        name="shipping_method_standard"
                        native-value="standard"
                      >
                        <p class="title is-6">ENVÍO A DOMICILIO</p>
                        <p class="subtitle is-6">
                          Envío por paquetería al domicilio que nos indiques.
                        </p>
                      </b-radio>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns is-6">
                <div class="columns is-mobile is-vcentered is-gapless">
                  <div class="column is-2">
                    <div class="p-2 has-text-centered">
                      <b-icon
                        class="has-text-primary"
                        size="is-large"
                        icon="map-marker-down"
                      ></b-icon>
                    </div>
                  </div>
                  <div>
                    <div class="p-2">
                      <b-radio
                        v-model="shipping_method"
                        name="shipping_method_pickup"
                        native-value="pickup"
                      >
                        <p class="title is-6">PICK-UP</p>
                        <p class="subtitle is-6">
                          Paga en línea y recoge directamente en sucursal.
                        </p>
                      </b-radio>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-8">
                <div v-if="shipping_method == 'pickup'">
                  <div class="has-text-primary mb-3">
                    <b
                      ><b-icon icon="map-marker-check-outline"></b-icon>
                      Recogerás tu pedido en nuestra sucursal.</b
                    >
                  </div>
                  <div class="columns">
                    <div class="column is-4">
                      <b-button
                        type="is-primary"
                        tag="a"
                        href="https://maps.app.goo.gl/8jM6bLd9tU1V8thH7"
                        icon-left="map-search"
                        target="_blank"
                        rel="noopener noreferrer"
                        >VER EN MAPS</b-button
                      >
                    </div>
                    <div class="column is-8">
                      <div>
                        <div class="has-text-primary mb-2">
                          <b>CENTRO COMERCIAL INTERLOMAS</b>
                        </div>
                        <span class="icon"
                          ><i class="mdi mdi-map-marker"></i
                        ></span>
                        <span class="has-text-grey"
                          ><b
                            >MOST INTERLOMAS, LOCAL X-05, PLANTA
                            ALTA</b
                          ></span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="shipping_method == 'standard'">
                  <div
                    v-if="shipping_details.has_free_shipping"
                    class="has-text-primary mb-3"
                  >
                    <div>
                      <b
                        ><b-icon icon="truck-check-outline"></b-icon> Envío
                        gratis disponible en pedidos mayores a
                        {{
                          shipping_details.free_shipping_required_amount
                            | currency
                        }}</b
                      >
                    </div>

                    <div
                      class="mt-3"
                      v-if="
                        parseFloat(order.subtotal) >=
                        parseFloat(
                          shipping_details.free_shipping_required_amount
                        )
                      "
                    >
                      <h5 class="title is-5 has-text-danger">
                        <b>¡Envío gratis aplicado!</b>
                      </h5>
                    </div>
                  </div>

                  <div v-html="shipping_details.details"></div>

                  <div class="mb-2">
                    <div
                      v-if="shipping_details.matches.length > 0"
                      class="p-3 has-background-light"
                    >
                      Enviando a <b>{{ destination }}</b>
                    </div>
                    <div
                      class="p-3 has-background-light has-text-danger"
                      v-else
                    >
                      Introduce un código postal válido.
                    </div>
                  </div>

                  <div class="columns">
                    <div class="column is-6">
                      <b-field label="Calcula el costo de envío:">
                        <b-input
                          @keydown.native.enter="getShippingDetails()"
                          v-model="postal_code"
                          :disabled="isSyncing > 0"
                          placeholder="Código Postal..."
                          type="search"
                          icon="magnify"
                        >
                        </b-input>
                        <p class="control">
                          <b-button
                            :disabled="isSyncing > 0"
                            :loading="isSyncing > 0"
                            @click="getShippingDetails()"
                            type="is-primary"
                            label="Calcular"
                          />
                        </p>
                      </b-field>
                    </div>
                    <div class="column is-6">
                      <b-field label="¿Tienes un cupón?">
                        <b-input
                          @keydown.native.enter="searchCouponCode()"
                          v-model="coupon_code"
                          :disabled="isSyncing > 0"
                          placeholder="Escribe aquí..."
                          type="text"
                          icon="sale"
                        >
                        </b-input>
                        <p class="control">
                          <b-button
                            :disabled="isSyncing > 0"
                            :loading="isSyncing > 0"
                            @click="searchCouponCode()"
                            type="is-primary"
                            label="¡Aplicar!"
                          />
                        </p>
                      </b-field>
                      <div v-if="order.coupon">
                        <div v-if="order.coupon.has_limits">
                          <div v-if="order.coupon.has_user_limit">
                            <div class="has-text-danger">
                              * Cupón limitado a
                              {{ order.coupon.user_limit }} por cliente.
                            </div>
                            <div class="is-size-7 has-text-grey">
                              Lo validaremos en el siguiente paso.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-4">
                <div
                  class="
                    mb-3
                    has-text-primary has-text-right has-text-centered-mobile
                  "
                >
                  <b
                    >{{ total_items | number }} PRODUCTO{{
                      total_items !== 1 ? "S" : ""
                    }}</b
                  >
                </div>
                <table class="table is-narrow is-fullwidth">
                  <tbody>
                    <tr>
                      <td class="has-text-right"><b>SUBTOTAL</b></td>
                      <td class="has-text-right">
                        <b>{{ order.subtotal | currency }}</b>
                      </td>
                    </tr>

                    <tr v-if="order.discount > 0">
                      <td class="has-text-right has-text-danger">
                        <b><b-icon icon="sale"></b-icon> DESCUENTO</b>
                        <span v-if="order.coupon">
                          <span v-if="order.coupon.coupon">
                            <span v-if="order.coupon.coupon.has_discount">
                              <span
                                v-if="
                                  order.coupon.coupon.discount_type ===
                                  'relative'
                                "
                                >{{
                                  order.coupon.coupon.discount_value | number
                                }}%</span
                              >
                            </span>
                          </span>
                        </span>
                      </td>
                      <td class="has-text-right has-text-danger">
                        <b>- {{ order.discount | currency }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td class="has-text-right">
                        <b>ENVÍO</b>
                        <div
                          class="has-text-danger"
                          v-if="order.coupon.has_free_shipping"
                        >
                          ¡Gratis!
                        </div>
                      </td>
                      <td class="has-text-right">
                        <div
                          v-if="!isSyncing && order.coupon.has_free_shipping"
                        >
                          <del class="has-text-grey">{{
                            shipping_details.amount | currency
                          }}</del>
                        </div>
                        <b>{{ order.shipping | currency }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td class="has-text-right has-text-primary is-size-4">
                        <b>TOTAL</b>
                      </td>
                      <td class="has-text-right has-text-primary is-size-4">
                        <b>{{ order.total | currency }}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-3" v-if="total_items > 0 && destination">
          <div class="card-content">
            <h5 class="title is-5 has-text-primary">Elige un método de pago</h5>

            <div class="columns is-multiline is-6">
              <!-- <div class="column is-6">
                <div class="columns is-mobile is-vcentered">
                  <div class="column is-3">
                    <img
                      src="/payments/visa-mastercard.png"
                      alt="Visa Mastercard"
                    />
                  </div>
                  <div class="column">
                    <b-radio
                      v-model="payment_provider"
                      name="name"
                      native-value="bzpay"
                    >
                      <p class="title is-6">VISA Y MASTERCARD</p>
                      <p class="subtitle is-6">
                        Pago con Tarjeta de Crédito o Débito
                      </p>
                    </b-radio>
                  </div>
                </div>
              </div> -->

              <div class="column is-6">
                <div class="columns is-mobile is-vcentered">
                  <div class="column is-3">
                    <img
                      src="/payments/visa-mastercard-amex.png"
                      alt="Visa Mastercard Amex"
                    />
                  </div>
                  <div class="column">
                    <b-radio
                      v-model="payment_provider"
                      name="name"
                      native-value="payclip"
                    >
                      <p class="title is-6">VISA, MASTERCARD y AMEX</p>
                      <p class="subtitle is-6">
                        Pago con Tarjetas de Crédito y Débito.
                      </p>
                    </b-radio>
                  </div>
                </div>
              </div>

              <div class="column is-6">
                <div class="columns is-mobile is-vcentered">
                  <div class="column is-3">
                    <img src="/payments/paypal.png" alt="PayPal" />
                  </div>
                  <div class="column">
                    <b-radio
                      v-model="payment_provider"
                      name="name"
                      native-value="paypal"
                    >
                      <p class="title is-6">PAYPAL</p>
                      <p class="subtitle is-6">Pago con tu cuenta de Paypal</p>
                    </b-radio>
                  </div>
                </div>
              </div>

              <div class="column is-6">
                <div class="columns is-mobile is-vcentered">
                  <div class="column is-3">
                    <img src="/payments/mercadopago.png" alt="Mercadopago" />
                  </div>
                  <div class="column">
                    <b-radio
                      v-model="payment_provider"
                      name="name"
                      native-value="mercadopago"
                    >
                      <p class="title is-6">Mercadopago</p>
                      <p class="subtitle is-6">
                        Pago con tu cuenta de Mercadopago
                      </p>
                    </b-radio>
                  </div>
                </div>
              </div>

              <div class="column is-6">
                <div class="columns is-mobile is-vcentered">
                  <div class="column is-3">
                    <img src="/payments/spei.png" alt="SPEI" />
                  </div>
                  <div class="column">
                    <b-radio
                      v-model="payment_provider"
                      name="name"
                      native-value="spei"
                    >
                      <p class="title is-6">Transferencia</p>
                      <p class="subtitle is-6">
                        Pago directo con transferencia SPEI
                      </p>
                    </b-radio>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="has-text-right has-text-centered-mobile mt-3"
          v-if="total_items > 0 && destination"
        >
          <b-button
            type="is-success"
            class="is-fullwidth-mobile"
            icon-right="arrow-right-bold"
            :disabled="!payment_provider || isSyncing > 0"
            :loading="isSyncing > 0"
            @click="goTo(fill_data_url)"
          >
            CONTINUAR CON LA COMPRA
          </b-button>
        </div>
      </section>
    </div>

    <b-modal v-model="isSelectingBlock">
      <div class="card">
        <div class="card-content">
          <div class="title is-5 has-text-primary has-text-centered">
            <b-icon icon="map-marker"></b-icon> Selecciona tu colonia
          </div>

          <div
            class="mb-1"
            v-for="(match, index) in shipping_details.matches"
            :key="index"
          >
            <b-button
              type="is-light has-text-dark has-text-weight-bold"
              expanded
              @click="selectMatch(index)"
              >{{ match.asentamiento }}</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import AppMappers from "@/store/app-global-mappers";
import CartApi from "@/api/cart";
import { debounce } from "lodash-es";
export default {
  name: "Cart",
  mixins: [AppMappers, CartApi],
  props: ["order_data", "fill_data_url"],
  data() {
    return {
      order: null,
      isSyncing: 0,
      isSearching: false,
      isSelectingBlock: false,
      hasError: false,
      postal_code: "",
      coupon_code: "",
      shipping_details: {
        details: "",
        amount: 0,
        has_free_shipping: false,
        free_shipping_required_amount: 0,
        matches: [],
        selected_index: 0,
      },
      payment_provider: null,
      shipping_method: "standard",
      has_cart_suggestions: false,
      cart_suggestions: {},
    };
  },


  created() {
    this.order = this.order_data;
    this.postal_code = this.$storage.get("order_postal_code", "");
    this.coupon_code = this.$storage.get("order_coupon_code", "");
    this.payment_provider = this.$storage.get("order_payment_provider", null);
    this.shipping_method = this.$storage.get(
      "order_shipping_method",
      "standard"
    );
    this.debouncedChangeItemQuantity = debounce(this.changeItemQuantity, 900);
  },

  computed: {
    total_items() {
      return Object.keys(this.order.items).length;
    },
    destination() {

      if (this.shipping_method === 'pickup') {
        return true;
      }

      if (this.shipping_details.matches.length > 0) {
        let match =
          this.shipping_details.matches[this.shipping_details.selected_index];
        return `${match.asentamiento}, ${match.municipio}, ${match.estado}, ${match.pais}.`;
      }
      return null;
    },
  },

  mounted() {
    let self = this;
    self.buildCartSuggestions();
    this.$nextTick(() => {
      this.setCartStep("cart");

      if (this.total_items === 0) {
        this.$storage.clear();
      }

      if (Object.keys(self.cart_suggestions).length > 0) {
        self.has_cart_suggestions = true;
      }

      self.getShippingDetails();
    });
  },

  methods: {
    goTo(path) {
      let self = this;
      self.isSyncing++;
      window.location.replace(path);
    },

    buildCartSuggestions() {
      let self = this;
      self.cart_suggestions = {};

      Object.keys(self.order.items).forEach((key) => {
        if (self.order.items[key].hasOwnProperty("cart_suggestions")) {
          let item_suggestions = self.order.items[key].cart_suggestions;

          if (item_suggestions instanceof Array) {
            item_suggestions.forEach((suggestion) => {
              if (
                self.cart_suggestions.hasOwnProperty(suggestion.code) ===
                  false &&
                self.order.items.hasOwnProperty(suggestion.code) === false
              ) {
                self.cart_suggestions[suggestion.code] = suggestion;
                self.has_cart_suggestions = true;
              }
            });
          }
        }
      });
    },

    getOrder() {
      let self = this;
      self.isSyncing++;
      self.api_get("get_order", (response) => {
        self.order = response.order;
        self.isSyncing--;
        self.fireCartChange({
          item_count: self.total_items,
          order_subtotal: self.order.subtotal,
          order_total: self.order.total,
        });
        self.getShippingDetails();

        self.$nextTick(() => {
          self.buildCartSuggestions();
        });
      });
    },

    changeItemQuantity(item) {
      let self = this;

      if (!this.production) {
        console.log("[LOG] Cart received event", item);
      }

      self.isSyncing++;
      self.api_update(
        "change_item_quantity",
        item.code,
        { quantity: item.quantity },
        (response) => {
          self.getOrder();
          self.isSyncing--;
        }
      );
    },

    removeItem(item) {
      let self = this;
      self.isSyncing++;
      self.api_update("remove_item", item.code, null, (response) => {
        self.getOrder();
        self.isSyncing--;
      });
    },

    setOrderShipping(amount) {
      let self = this;
      self.order.shipping = amount;
      self.isSyncing++;
      self.api_post("set_order_shipping", { amount: amount }, (response) => {
        self.isSyncing--;
        self.order = response.order;
      });
    },
    
    setOrderShippingMethod(method) {
      let self = this;
      self.order.shipping_method = method;
      self.isSyncing++;      

      self.api_post(
        "set_order_shipping_method",
        { method: method },
        (response) => {
          self.isSyncing--;
          self.order = response.order;
          
          if(method === 'standard') {
            self.getShippingDetails();
          }

        }
      );
    },

    setOrderCoupon(coupon) {
      let self = this;
      self.isSyncing++;
      self.api_post("set_order_coupon", { coupon: coupon }, (response) => {
        self.isSyncing--;
        self.order = response.order;

        this.$buefy.dialog.alert({
          message: `<b>Cupón activado</b>`,
          type: "is-success",
          hasIcon: true,
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      });
    },

    removeOrderCoupon() {
      let self = this;
      self.isSyncing++;
      self.api_post("remove_coupon", null, (response) => {
        self.isSyncing--;
        self.order = response.order;
        self.getShippingDetails();
      });
    },

    emptyCart() {
      let self = this;
      self.isSyncing++;
      self.api_get("empty_cart", (response) => {
        self.getOrder();
        self.isSyncing--;
        self.postal_code = "";
        self.coupon_code = "";

        self.setStoreShippingDetails({
          amount: 0,
          has_free_shipping: false,
          free_shipping_required_amount: 0,
        });

        self.has_cart_suggestions = false;
        self.cart_suggestions = {};

        self.$storage.clear();
      });
    },

    searchCouponCode() {
      let self = this;
      if (this.coupon_code.trim().length === 0) {
        return false;
      }

      let filters = {
        coupon_code: this.coupon_code,
      };

      self.isSyncing++;
      this.api_filtered("get_coupon", filters, (response) => {
        self.isSyncing--;

        if (!this.production) {
          console.log(response);
        }

        if (response) {
          // Not found
          if (response.coupon_exists === false) {
            this.$buefy.dialog.alert({
              message: `<b>¡Vaya!</b>. No hemos encontrado un cupón con el código <b>${self.coupon_code}</b>`,
              type: "is-danger",
              hasIcon: true,
              ariaRole: "alertdialog",
              ariaModal: true,
            });

            self.removeOrderCoupon();
            return false;
          }

          // Is not active or is expired
          if (
            response.is_active === false ||
            response.is_expired === true ||
            response.is_usable === false
          ) {
            this.$buefy.dialog.alert({
              message: `<b>¡Lo sentimos!</b>. el código <b>${self.coupon_code}</b> se encuentra expirado o agotado.`,
              type: "is-warning",
              hasIcon: true,
              ariaRole: "alertdialog",
              ariaModal: true,
            });

            self.removeOrderCoupon();
            return false;
          }

          // Not minimum purchase amount
          if (self.order.subtotal < response.minimum_purchase_amount) {
            this.$buefy.dialog.alert({
              message: `<b>Agrega más productos para activar el cupón</b>. El código <b>${self.coupon_code}</b> requiere un monto mínimo de $<b>${response.minimum_purchase_amount}</b> para activarse`,
              type: "is-warning",
              hasIcon: true,
              ariaRole: "alertdialog",
              ariaModal: true,
            });

            self.removeOrderCoupon();
            return false;
          }

          self.setOrderCoupon(response);
        }
      });
    },

    getShippingDetails() {
      let self = this;
      self.hasError = false;

      if (this.postal_code.trim().length === 0) {
        return false;
      }

      if (this.shipping_method === 'pickup') {
        return false;
      }

      let filters = {
        postal_code: this.postal_code,
        order_total: this.order.subtotal,
      };
      self.isSyncing++;
      this.api_filtered("get_shipping", filters, (response) => {
        self.isSyncing--;

        if (!this.production) {
          console.log("[LOG] Cart: get_shipping response", response);
        }

        if (response && response.amount !== null) {
          self.shipping_details.details = response.details;
          self.shipping_details.amount = response.amount;
          self.shipping_details.has_free_shipping = response.has_free_shipping;
          self.shipping_details.free_shipping_required_amount =
            response.free_shipping_required_amount;

          self.shipping_details.matches = response.matches || [];

          if (self.shipping_details.matches.length === 1) {
            self.shipping_details.selected_index = 0;
          }

          if (self.shipping_details.matches.length > 1) {
            self.askForBlock();
          }

          self.setOrderShipping(response.amount);
          self.hasError = false;

          self.setStoreShippingDetails({
            amount: self.shipping_details.amount,
            has_free_shipping: self.shipping_details.has_free_shipping,
            free_shipping_required_amount:
              self.shipping_details.free_shipping_required_amount,
          });
        } else {
          self.hasError = true;
        }
      });
    },
    askForBlock() {
      let self = this;
      self.isSelectingBlock = true;
    },
    selectMatch(index) {
      this.shipping_details.selected_index = index;
      this.isSelectingBlock = false;
    },
  },
  watch: {
    postal_code(value) {
      this.$storage.set("order_postal_code", value);
    },
    coupon_code(value) {
      this.$storage.set("order_coupon_code", value);
    },
    payment_provider(value) {
      this.$storage.set("order_payment_provider", value);
    },
    shipping_method(value) {
      this.$storage.set("order_shipping_method", value);
      this.setOrderShippingMethod(value);
    },
    shipping_details: {
      deep: true,
      handler() {
        this.$storage.set("shipping_details", this.shipping_details);
      },
    },
  },
};
</script>